// French translations
export default {
  'general.logout': 'Connectez - Out',
  'general.sessionExpired':
    'Votre session a expiré. Veuillez vous reconnecter.',
  'general.error': "quelque chose s'est mal passé",
  'general.tryAgain': 'Please try again later',
  'general.login': 'Login',
  'login.welcome': 'Bienvenue sur Piction.',
  'login.loginMessage': ' Veuillez vous connecter.',
  'general.reLogin': 'Veuillez vous reconnecter.',
  'general.loginCode': 'Please enter authentication code',
  'general.language': 'Langue',
  'general.language.english': 'Anglaise',
  'general.language.french': 'Française',
  'general.language.german': 'Allemande',
  'general.scrollToTop': 'Défiler vers le haut.',
  'general.fillMandatory': 'Please Fill All Mandatory  Values',
  'general.invalidEmail': 'Invalid Email Address',
  'general.select': 'Sélectionner',
  'general.cancel': 'Annuler',
  'general.add': 'Ajouter',
  'general.remove': 'Supprimer',
  'general.save': 'Sauvegarder',
  'general.create': 'Créer',
  'general.delete': 'Supprimer',
  'general.update': 'Update',
  'general.close': 'Fermer',
  'general.download': 'Download',

  'umoMediaView.previewUnavailable': 'Aperçu non disponible.',
  'umoThumbnail.sensitiveContentLabel': 'Contenu Sensible',

  'login.invalidCode': '',
  'login.codeRegistryRequired':
    'Two-Factor Authentication is required for your account',
  'login.codeRegistryMsg': 'Please register with the following QR code',
  'login.codeDisplayOnceWarning':
    'Please note: The QR code will only appear once',
  'login.scanToLinkMsg':
    'Scan the QR code to link your account with a two-factor authentication app',
  'login.registerBtn': 'Register',

  'searchResults.sortBy': 'Trier par',
  'searchResults.sortByNone': 'None',
  'searchResults.sortManually': 'Manually Sort Media',
  'searchResults.noItemFound': 'Aucun élément trouvé!',

  'searchResults.filter': 'Filtre',
  'searchResults.filter.date': 'Date',
  'searchResults.filter.date.from': 'De',
  'searchResults.filter.date.to': 'À',
  'searchResults.filter.date.all': 'TOUS',
  'searchResults.filter.applyFiltersButton': 'Appliquer les filtres',

  'searchResults.options': 'Options',
  'searchResults.options.selection': 'Sélection',
  'searchResults.options.selection.selectPage': 'Sélectionner Tout sur la Page',
  'searchResults.options.selection.selectSearch':
    'Sélectionner Tout les résultats',
  'searchResults.options.selection.deselectAll': 'Tout désélectionner',
  'searchResults.options.selection.bulkEdit': 'Bulk Edit',
  'searchResults.options.actions': 'Actions',
  'searchResults.options.actionsWorkspaceTitle': 'Espace Actions',
  'searchResults.options.actions.addToWorkspace': 'Ajouter à {workspaceName}',
  'searchResults.options.actions.addToWorkspace.default': 'espace',
  'searchResults.options.actions.removeSelectedFromWorkspace':
    'Enlever les sélections de l’espace',
  'searchResults.options.actions.exportAllToExcel':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Excel (toutes les balises)',
  'searchResults.options.actions.exportTagsToExcel':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Excel (balises sélectionnées)',
  'searchResults.options.actions.exportToPPT':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers PPT',
  'searchResults.options.actions.exportToZip':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers ZIP',
  'searchResults.options.actions.exportToPDF':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers PDF',
  'searchResults.options.actions.batchDownload': 'Download all workspace items',
  'searchResults.options.actions.emailAll': 'Tout envoyer par courriel',
  'searchResults.options.actions.relateAllInWorkspace':
    'Relier tous les éléments dans l’espace',
  'searchResults.options.actions.umosExpectedError':
    'Éléments prévus à trouver',
  'searchResults.options.actions.noUMOsSelected': 'Aucun élément trouvé',
  'searchResults.options.actions.shareAsPortal': 'Partager en tant que portail',
  'searchResults.options.actions.shareExternalPortal':
    'Partager en tant que portail externe',
  'searchResults.options.actions.saveToDropbox':
    'Sauvegarder {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Dropbox',
  'searchResults.options.actions.resize':
    'Redimensionner {selectCount, plural, =0 {tout} other {les objets sélectionnés}}',
  'searchResults.options.actions.dropboxSaveSuccess':
    'Succès! Les fichiers ont été sauvegardés dans votre DropBox',
  'searchResults.options.actions.dropboxSaveError':
    'Une erreur est survenue lors de la sauvegarde de vos fichiers dans DropBox',
    'searchResults.options.actions.tooManyItems':
    'un maximum de {maxItems} objets peut être sélectionné pour la {templateName}',
  'searchResults.compare': 'Comparer',
  'searchResults.copy': 'Copie',
  'searchResults.copy-screen.overlayMessageCategory':
    'Sélectionner la catégorie de destination',
  'searchResults.copy-screen.overlayMessageWorkspace': `Sélectionner l’espace de destination`,
  'searchResults.copy-screen.overlayMessageCancel':
    'Appuyer sur Échap pour annuler',
  'searchResults.download.tooManyItems':
    'Unable to download more than {maxItems} items',
  'searchResults.download.selectAnyItem': 'Select items to download',

  'searchResults.loadingHeader': 'Chargement...',
  'searchResults.previousSearch': 'Back to:',
  'searchResults.previousSearchAdv': 'Recherche avancée',
  'searchResults.objectsFoundHeader':
    '{objectsFoundCount} {objectsFoundCount, plural, one {objet} other {objets}} a trouvé',
  'searchResults.objectSelected':
    '{objectsSelectedCount} {objectsSelectedCount, plural, one {objet} other {objets}} sélectionné',

  'categoryDialog.editHeader': 'Éditer la catégorie',
  'categoryDialog.saveButton': 'Sauvegarder',
  'categoryDialog.createChildHeader': 'Ajouter une sous-catégorie',
  'categoryDialog.createButton': 'Créer',
  'categoryDialog.addHeader': 'Ajouter une catégorie',
  'categoryDialog.namePlaceholder': 'Entrer un nom de catégorie',
  'categoryDialog.deleteCheckbox': 'Supprimer cette catégorie',
  'categoryDialog.deleteButton': 'Supprimer',
  'categoryDialog.deleteInProgress': 'Suppression de catégorie en cours',
  'categoryDialog.deleteSuccess': 'Suppression de catégorie réussie',

  'categoryMoveDialog.successMoveMessage': 'Déplacement réussi',
  'categoryMoveDialog.InProgressMoveMessage': 'Déplacement en cours',
  'categoryMoveDialog.successCopyMessage': 'Copie réussie',
  'categoryMoveDialog.InProgressCopyMessage': 'Copie en cours',
  'categoryMoveDialog.moveHeader': 'Déplacer la catégorie',
  'categoryMoveDialog.moveSubtext':
    'Sélectionner le nouveau parent pour "{categoryName}"',
  'categoryMoveDialog.cancelButton': 'Annuler',
  'categoryMoveDialog.moveButton': 'Déplacer',

  'messageDialog.dismissAllButton': 'Fermer',

  'metaAttach.attachButton': 'Affecter des métadonnées',
  'metaAttach.replaceCheckbox':
    'Remplacer les métadonnées (au lieu de les ajouter)',
  'metaAttach.defaultAttachBehavior': 'Défaut: Annexer aux métadonnées',
  'metaAttach.attachArea':
    'Attach the metadata to selected items by dragging items here\n\n\nOR',
  'metaAttach.umosExpectedError': 'Éléments prévus à trouver',
  'metaAttach.genericPartialError':
    'Il y a eu au moins une erreur lors de l’affectation des métadonnées. Veuillez réessayer.',
  'metaAttach.currentValues': 'Current Values',
  'metaAttach.editCurValues': 'Edit Meta Values',
  'metaAttach.PopulateButton': 'Populate',
  'metaAttach.RelationshipDesc': 'Relationship Description',
  'metaAttach.metaPopulateDragDrop':
    'Add the selected item IDs to the "{tagName}" metatag by\n\nDragging the items here\n\nOR',
  'metaAttach.populateMetatagDoesntExist':
    'a metatag of type "UMO Insert Group" could not be found.',
  'metaAttach.metaCopyDragDrop':
    'Copy metadata from {umoName} to the selected items by\n\nDragging the items here\n\nOR',
  'metaAttach.maxResultsError':
    'Un maximum de {maxItems} objets peut être copié à la fois.',
  'metaPanel.title': 'Meta Panel:',

  'navOptions.setsHeader': 'Éléments marquants',
  'navOptions.workspaceHeader': 'Espaces',
  'navOptions.categoryHeader': 'Catégories',
  'navOptions.adminHeader': 'Admin',
  'navOptions.homeHeader': 'Accueil',
  'navOptions.formsHeader': 'Formulaires',
  'navOptions.thesaurusHeader': 'Thesaurus',
  'navOptions.reportsHeader': 'REPORTS',

  'navAdminPanel.metaAttach': 'Affectation de métadonnées',
  'navAdminPanel.manageUsers': 'Gestion des utilisateurs',
  'navAdminPanel.usersAndRoles': 'Utilisateurs et rôles',
  'navAdminPanel.adminHeader': 'Admin',
  'navAdminPanel.manageCategoryRoles': 'Gestionnaire des rôles de catégorie',
  'navAdminPanel.publishBtn': 'Publier le(s) média(s)',
  'navAdminPanel.createRelationalBtn': 'Add New Record',
  'navAdminPanel.manageLoader': 'Manage Loader',
  'navAdminPanel.importMetadata': 'Import Metadata',
  'navAdminPanel.recycleBin': 'Corbeille',

  'navReportsPanel.editHistory': 'Edit History',
  'navReportsPanel.RecordHeader': 'Reports',
  'navReportsPanel.umoID': 'UMO ID',
  'navReportsPanel.categoryID': 'Category ID',
  'navReportsPanel.date': 'Date',
  'navReportsPanel.user': 'User',
  'navReportsPanel.tagName': 'Tag Name',
  'navReportsPanel.change': 'Change',
  'navReportsPanel.submit': 'Submit',
  'navReportsPanel.downloadCSV': 'Download CSV',
  'navReportsPanel.dateFrom': 'Date From',
  'navReportsPanel.dateTo': 'Date To',
  'navReportsPanel.enterUMOID': 'Enter UMO ID',
  'navReportsPanel.downloadList': 'Download List',
  'navReportsPanel.type': 'Type',
  'navReportsPanel.filename': 'Filename',

  'adminPurge.purgeConfirmationTitle': 'Corbeille vide',
  'adminPurge.purgeConfirmationButton': 'Vider',
  'adminPurge.purgeConfirmMessage':
    'Êtes-vous sûr de vouloir supprimer définitivement tous les éléments de la corbeille? Cette action est irréversible.',
  'adminPurge.purgeFailed': 'Une erreur est survenue lors de la suppression de la corbeille',
  'adminPurge.purgeSuccess': 'Corbeille vide avec succès',

  'adminPublish.publishTitle': 'Publier le(s) média(s)',
  'adminPublish.publishBtn': 'COMMENCER',
  'adminPublish.publishBtnTitle':
    'Voulez-vous vraiment commencer le processus de synchronisation?',
  'adminPublish.publishBtnStart': 'Lancer la synchronisation',
  'adminPublish.publishBtnCancel': 'Annuler',
  'adminPublish.publishProc.Success':
    'Processus de synchronisation commencé avec succès',
  'adminPublish.publishProc.Fail':
    'Une erreur s’est produite lors du pousser du ou des médias vers le portail',
  'adminPublish.publishProc.EmptyQueue':
    'Rien dans la file d’attente. Tous les actifs sont déjà publiés',
  'adminPublish.publishSubTitle':
    'Tous les actifs balisés en conséquence seront publiés vers le portail',

  'navCategoryPanel.workspaceToCategoryError':
    'Vous ne pouvez pas faire glisser des objets de l’espace dans une catégorie',
  'navCategoryPanel.noEditRoleError':
    'Vous n’avez pas la permission de déplacer ou de copier des éléments dans {catName}',
  'navCategoryPanel.noMoveRoleError':
    'Vous n’avez pas la permission de déplacer des éléments depuis la catégorie actuelle',
  'navCategoryPanel.categoryHeader': 'Catégories',
  'navCategoryPanel.createGlobalCategoryBtn': 'Add Global Category',
  'navCategoryPanel.addCategoryButton': 'Ajouter une catégorie',
  'navCategoryPanel.menuAddChild': 'Ajouter une sous-catégorie',
  'navCategoryPanel.menuUploadToChild': 'Téléverser',
  'navCategoryPanel.menuBulkEditChild': 'Bulk Edit',
  'navCategoryPanel.menuEditChild': 'Éditer',
  'navCategoryPanel.menuMoveChild': 'Déplacer',
  'navCategoryPanel.menuSortChild': 'Sort Items',

  'navFormsPanel.formHeader': 'Formulaires',

  'navWorkspacePanel.workspaceHeader': 'Espaces',
  'navWorkspacePanel.addWorkspaceButton': 'Ajouter un espace',
  'navWorkspacePanel.menuAddChild': 'Ajouter un sous-espace',
  'navWorkspacePanel.menuEditChild': 'Éditer',

  'navHighlightsPanel.highlightsHeader': 'Éléments marquants',
  'navHighlightsPanel.addSetButton': 'Ajouter un ensemble d’éléments marquants',
  'navHighlightsPanel.menuEditChild': 'Éditer',

  'navThesaurusPanel.thesaurusHeader': 'Thésaurus',
  'navThesaurusPanel.addTermButton': 'Ajouter un terme',
  'navThesaurusPanel.menuEditChild': 'Éditer',
  'navThesaurusPanel.attachSuccessful': 'Ajouté Avec Succès',

  'thesaurusDialog.editHeader': 'Éditer un terme',
  'thesaurusDialog.saveButton': 'Sauvegarder',
  'thesaurusDialog.createChildHeader': 'Ajouter un sous-terme',
  'thesaurusDialog.createButton': 'Créer',
  'thesaurusDialog.addHeader': 'Ajouter un terme',
  'thesaurusDialog.namePlaceholder': 'Entrer un nom de terme',
  'thesaurusDialog.deleteCheckbox': 'Supprimer ce terme',
  'thesaurusDialog.deleteButton': 'Supprimer',
  'thesaurusDialog.deleteInProgress': 'Suppression en cours',
  'thesaurusDialog.deleteSuccess': 'terme supprimé avec succès',

  'pagination.previousButton': 'Précédent',
  'pagination.pageNumberOfTotal': 'de {pageTotal}', // i.e "2 of 3"
  'pagination.nextButton': 'Prochain',

  'panelTree.noItemsMessage': 'Aucun élément à afficher',

  'searchBar.defaultSearch': 'Recherche par défaut',
  'searchBar.advancedSearch': 'Recherche avancée',
  'searchBar.advancedButton': 'AVANCÉE',
  'searchBar.advanced.selectMetadataLabel': 'Sélectionner un groupe de métadonnées',
  'searchBar.advanced.selectCollectionLabel': 'Sélectionner une collection ou une catégorie',
  'searchBar.advanced.availableSchemas': 'Sélectionner les groupes de métadonnées',
  'searchBar.advanced.selectAllSchemas': 'TOUT SÉLECTIONNER',
  'searchBar.advanced.collectionsRetrieveError':
    'Une erreur s’est produite. Cliquez pour réessayer',
  'searchBar.advanced.mediaType': 'Type de média',
  'searchBar.advanced.addMetatagButton': 'Ajouter une métabalise',
  'searchBar.advanced.searchButton': 'Recherche',
  'searchBar.advanced.clearButton': 'Effacer',
  'searchBar.advancedForm.operatorAnd': 'ET',
  'searchBar.advancedForm.operatorOr': 'OU',
  'searchBar.advancedForm.operatorNot': 'NON',
  'searchBar.advancedForm.anyMetatagOption': 'N’importe quelle métabalise',
  'searchBar.advancedForm.searchContainS': 'Contient',
  'searchBar.advancedForm.searchNotContain': 'Ne contient pas',
  'searchBar.advancedForm.searchStartsWith': 'Commence par',
  'searchBar.advancedForm.searchEndsWith': 'Termine par',
  'searchBar.advancedForm.searchTermPlaceholder': 'Terme de recherche',
  'searchBar.advanced.newSearchName': 'Nouveau nom de recherche',
  'searchBar.advanced.saveSearchButton': 'Sauvegarder & Rechercher',
  'searchBar.advanced.savedSearches': 'Vos recherches sauvegardées',
  'searchBar.advanced.searchQuery': 'Requête de recherche',
  'searchBar.advanced.searchNameMissing': 'Nom de recherche manquant',
  'searchBar.advanced.searchSaveError':
    'Une erreur est survenue lors de la tentative de sauvegarde de votre recherche',
  'searchBar.advanced.deleteSearchButton': 'Supprimer {searchName}',
  'searchBar.advanced.saveSearchExists': 'Le nom existe déjà',
  'searchBar.advanced.specificCollection': 'Rechercher uniquement dans la collection actuelle',
  'searchBar.advanced.selectToStart': 'Veuillez sélectionner une recherche sauvegardée, une collection ou une catégorie pour commencer.',
  'searchBar.advanced.enableCategoryFilter': 'Rechercher uniquement dans les catégories sélectionnées',
  'searchBar.advancedForm.helpTooltip.content':
    'Pour les champs {numberText} et {dateText}, utilisez:{br}'
    + '{rangeExample} - rechercher des résultats dans une plage{br}'
    + '{lessExample} - rechercher des résultats avec une valeur minimale{br}'
    + '{greaterExample} - rechercher des résultats avec une valeur maximale{br}'
    + '{br} EXAMPLES:{br} {example1}{br} {example2}{br} {example3}{br} {example4}',


  'searchBar.simple.searchPlaceholder': 'Rechercher',
  'searchBar.simple.typeAny': 'N’importe',
  'searchBar.simple.typeImage': 'Image',
  'searchBar.simple.typeVideo': 'Vidéo',
  'searchBar.simple.typeAudio': 'Audio',
  'searchBar.simple.typeDocument': 'Document',
  'searchBar.simple.typeRecord': 'Enregistrement',

  'umoDetailView.requestUMOError': 'Aucun OMU trouvé',
  'umoDetailView.primaryImageLabel': 'Il s’agit de l’image principale',
  'umoDetailView.setAsPrimaryButton':
    'Cliquer pour établir cette image comme image principale.',
  'umoDetailView.setAsPrimaryWarningMessage':
    'Voulez-vous vraiment utiliser cette image comme image principale?',
  'umoDetailView.addToWorkspaceButton': 'Ajouter à {workspaceName}',
  'umoDetailView.addToWorkspaceGenericButton': 'Ajouter à l’espace',
  'umoDetailView.DownloadImageButton': 'Téléchargements',
  'umoDetailView.DownloadViewedImageTooltip': 'Télécharger l’image affichée',
  'umoDetailView.metadataHeader': 'Métadonnées',
  'umoDetailView.relatedItemHeader': 'Éléments liés:',
  'umoDetailView.loadingModel':
    'Loading Model, this could take some time. Please wait.',
  'umoDetailView.renderingModel': 'Rendering Model. Please wait.',
  'umoDetailView.metadataLanguageTooltip': 'View in another language',

  'umoCardView.save': 'Sauvegarder',
  'umoCardView.dueDate': 'Échéance',
  'umoCardView.status': 'Statut',
  'umoCardView.delete': 'Supprimer',
  'umoCardView.deleteCard': 'Supprimer la carte',
  'umoCardView.newComment': 'Nouvelle',
  'umoCardView.edit': 'Éditer',
  'umoCardView.edited': '(Édité)',
  'umoCardView.cancel': 'Annuler',
  'umoCardView.attachments': 'Pièces jointes',
  'umoCardView.uploading': 'Téléversement en cours',
  'umoCardView.comments': 'Commentaires',
  'umoCardView.description': 'Description',
  'umoCardView.addComment': 'Ajouter un commentaire',
  'umoCardView.noAttachments': 'Rien n’est joint encore',
  'umoCardView.submit': 'Envoyer',
  'umoCardView.uploadButton': 'Téléverser',
  'umoCardView.commentBy': 'Commentaire par {name}',
  'umoCardView.getCardError':
    'Une erreur s’est produite lors de l’obtention des données sur la carte',
  'umoCardView.delCommentError':
    'Une erreur s’est produite lors de la tentative de suppression du commentaire',
  'umoCardView.delAttachmentError':
    'Une erreur s’est produite lors de la tentative de suppression de la pièce jointe',
  'umoCardView.delCardError':
    'Une erreur s’est produite lors de la tentative de suppression de la carte',
  'umoCardView.delCardVerify': 'Voulez-vous vraiment supprimer cette carte?',
  'umoCardView.delCommentUndo': 'Annuler la suppression du commentaire',
  'umoCardView.delFileUndo': 'Annuler la suppression du fichier',
  'umoCardView.undo': 'Annuler',
  'umoCardView.uploadFileError':
    'Une erreur s’est produite lors de la tentative de téléchargement du fichier',
  'umoCardView.addCommentError':
    'Une erreur s’est produite lors de la tentative de sauvegarde du commentaire',
  'umoCardView.inCategory': 'Dans {catName}',
  'umoCardView.tabGeneral': 'Général',
  'umoCardView.tabComments': 'Commentaires',
  'umoCardView.tabMetadata': 'Métadonnées',
  'umoCardView.updateCardError': 'An error occurred while updating the card',
  'umoCardView.tabHistory': 'histoire',
  'umoCardView.historyID': 'ID',
  'umoCardView.historyName': 'Nom',
  'umoCardView.historyDetails': 'Détails',
  'umoCardView.historyDate': 'Date',
  'umoCardView.historyNone': 'Pas d`historique sur l`élément',

  'umoGridItem.relatedItemTagLabel': 'Éléments liés',
  'umoGridItem.relatedItemTagDescription': 'Éléments liés apparentés',
  'umoGridItem.alternateItemTagLabel': 'Substituts',
  'umoGridItem.alternateItemTagDescription':
    'Autres images pour l’image principale',
  'umoGridItem.addToWorkspaceTooltip': 'Ajouter à "{workspaceName}"',
  'umoGridItem.selectWorkspaceTooltip': 'Veuillez sélectionner un espace',
  'umoGridItem.reportImageTooltip': 'Signaler un ou des médias',
  'umoGridItem.shareImageTooltip': 'Partager les médias',
  'umoGridItem.viewMetaDataTooltip': 'View Metadata',
  'umoGridItem.viewDetailsButton': 'Afficher les détails',
  'umoGridItem.menuEditMetaData': 'Éditer les métadonnées',
  'umoGridItem.menuCrop': 'Recadrer',
  'umoGridItem.menuRotate': 'Rotate',
  'umoGridItem.menuMirror': 'Mirror',
  'umoGridItem.menuImageAnnotator': 'Annotateur de image',
  'umoGridItem.menuResize': 'Redimensionner',
  'umoGridItem.menuAudioAnnotator': 'Annotateur de audio',
  'umoGridItem.menuVideoAnnotator': 'Annotateur de vidéo',
  'umoGridItem.menuVideoSnippet': 'Extrait de vidéo',
  'umoGridItem.menuViewPeers': 'Afficher les éléments apparentés',
  'umoGridItem.menuEditMeta': 'Éditer les métadonnées',
  'umoGridItem.menuMetaPopulate': 'Media Populate',
  'umoGridItem.menuNoDownloadsAvailableMessage':
    'Aucun téléchargement disponible',
  'umoGridItem.toolsHeader': 'Outils',
  'umoGridItem.menuDownloadsHeader': 'Téléchargements',
  'umoGridItem.menuRelatedImagesHeader': 'Images liées',
  'umoGridItem.menuToolsHeader': 'Outils',
  'umoGridItem.cropUnsupportedTypes':
    'EN Crop is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.rotateUnsupportedTypes':
    'Rotate is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.mirrorUnsupportedTypes':
    'Mirror is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.noDerivativeAccess':
    'Aucun dérivé disponible pour cette image',
  'umoGridItem.menuSimilarColor': 'Similar Colored Images',
  'umoGridItem.menuImageMatch': 'Matching Images',
  'umoGridItem.menuGglLandmark': 'Landmarks Recognition',
  'umoGridItem.menuGglLabels': 'Labels Recognition',
  'umoGridItem.menuGglReverse': 'Reverse Image Recognition',
  'umoGridItem.menuGglHandwriting': 'Handwriting Recognition',
  'umoGridItem.menuGglText': 'Text Recognition',
  'umoGridItem.menuAmznFacial': 'Facial Recognition',

  'umoListItem.fileName': 'Nom du Fichier',
  'umoListItem.type': 'Type',
  'umoListItem.size': 'Taille du Fichier',
  'umoListItem.height': 'Hauteur (px)',
  'umoListItem.width': 'Largeur (px)',
  'umoListItem.duration': 'Durée',
  'umoListItem.dateCreated': 'Date de Chargement',

  'workspace.dropRestrictionError':
    'Vous ne pouvez faire glisser les objets des espaces que d’un espace à un sub-espace.',

  'workspaceDialog.editWorkspaceHeader': 'Éditer l’espace',
  'workspaceDialog.saveButton': 'Sauvegarder',
  'workspaceDialog.attachments': 'Pièces jointes',
  'workspaceDialog.addChildWorkspaceHeader': 'Ajouter un sous-espace',
  'workspaceDialog.createButton': 'Créer',
  'workspaceDialog.addWorkspaceHeader': 'Ajouter un espace',
  'workspaceDialog.shareLabel': 'Partager',
  'workspaceDialog.sharePlaceholder':
    'Sélectionnez les utilisateurs avec lesquels vous partagerez votre espace',
  'workspaceDialog.shareRemoveAll': 'Tout supprimer',
  'workspaceDialog.nameLabel': 'Nom',
  'workspaceDialog.namePlaceholder': 'Entrer le nom de l’espace',
  'workspaceDialog.descriptionLabel': 'Description',
  'workspaceDialog.descriptionPlaceholder': 'Entrer la description de l’espace',
  'workspaceDialog.expiryLabel': 'Expiry Date:',
  'workspaceDialog.sharingSecurityLabel': 'Sharing Security:',
  'workspaceDialog.sharingSecurityCheckbox': 'Public | Secure',
  'workspaceDialog.sharingSecurityHelper':
    'Public mode allows users to view all assets in the workspace.\n\nSecure mode allows users to only view assets they already have access to',
  'workspaceDialog.ownerLabel': 'Workspace Owner:',
  'workspaceDialog.cancelButton': 'Annuler',
  'workspaceDialog.deleteButton': 'Supprimer',
  'workspaceDialog.deleteWorkspace':
    'La suppression de cet espace de travail entraînera celle de tous les sous-espaces. Ce processus pourrait prendre quelques instants.',
  'workspaceDialog.deleteSuccess': 'Suppression de l’espace de travail réussie',
  'workspaceDialog.unsubscribeButton': 'Unsubscribe',
  'workspaceDialog.unsubscribeFromWS':
    'Are you sure you want to unsubscribe from this workspace?',
  'workspaceDialog.unsubscribeSuccess':
    'You have been successfully unsubscribed from this workspace',
  'workspaceDialog.nameExists': 'Il y a déjà un espace de travail du même nom',
  'workspaceDialog.errorOccurred':
    'Une erreur s’est produite lors de la sauvegarde de votre espace de travail',
  'workspaceDialog.downloadRuleList': 'External Users Download Rule:',
  'workspaceDialog.downloadRuleListHelper':
    'Select a download rule to be used for portal users',
  'workspaceDialog.downloadRuleListEmpty':
    'No External Download Rules to display.',
  'workspaceDialog.downloadRuleSetting': 'Download Setting:',
  'workspaceDialog.downloadRuleSettingHelper':
    'Please refer to workspace owner in order to change the available download derivatives',

  'mainDialog.title': 'Share Links',
  'mainDialog.subTitle': 'Share media item {umoName}',
  'mainDialog.copy': 'Copied',
  'mainDialog.copyTooltip': 'Copy to Clipboard',

  'highlightSetDialog.editWorkspaceHeader':
    'Éditer un ensemble d’éléments marquants',
  'highlightSetDialog.addWorkspaceHeader':
    'Ajouter un ensemble d’éléments marquants',
  'highlightSetDialog.namePlaceholder': 'Entrer le nom de l’ensemble',
  'highlightSetDialog.deleteSuccess': 'Ensemble supprimé avec succès',
  'highlightSetDialog.nameExists': 'Il y a déjà un ensemble du même nom',
  'highlightSetDialog.errorOccurred':
    'Une erreur s’est produite lors de la sauvegarde de votre ensemble',

  'workspaceEmailDialog.emailSentSuccessMessage': 'Envoi du courriel réussi',
  'workspaceEmailDialog.emailWorkspaceHeader': 'Envoyer l’espace par courriel',
  'workspaceEmailDialog.emailWorkspaceSubtext':
    'Utilisez ce formulaire pour envoyer le contenu de cet espace par courriel',
  'workspaceEmailDialog.emailWorkspacePortal':
    'Utilisez ce formulaire pour créer un compte temporaire doté d’un accès à cet espace de travail.',
  'workspaceEmailDialog.namePlaceholder': 'Votre nom',
  'workspaceEmailDialog.accountNamePlaceholder': 'Nom du compte',
  'workspaceEmailDialog.toEmailPlaceholder': 'Adresse des destinataires',
  'workspaceEmailDialog.toEmailSubtext':
    'Utilisez une virgule ou un point-virgule pour séparer les adresses',
  'workspaceEmailDialog.messagePlaceholder': 'Message',
  'workspaceEmailDialog.cancelButton': 'Annuler',
  'workspaceEmailDialog.sendButton': 'Envoyer',
  'workspaceEmailDialog.DMZMessage':
    'It might take a few minutes for all items to appear in the DMZ workspace',

  'workspaceResizeDialog.mainTitle': 'Redimensionner les images',
  'workspaceResizeDialog.optionsTitle': 'Options de redimensionnement',
  'workspaceResizeDialog.optionsType': 'Type',
  'workspaceResizeDialog.optionsWidth': 'Largeur',
  'workspaceResizeDialog.optionsDPI': 'DPI',
  'workspaceResizeDialog.optionsQuality': 'Qualité',
  'workspaceResizeDialog.optionsEmbedMetadata':
    'Incorporer les métadonnées {xmp}',
  'umoModifyDialog.buttonCancel': 'Annuler',
  'umoModifyDialog.buttonApply': 'Appliquer',
  'umoModifyDialog.tabResize': 'Redimensionner',
  'umoModifyDialog.tabCrop': 'Recarder',
  'umoModifyDialog.tabCopy': 'Copier',
  'umoModifyDialog.tabRotate': 'Faire Pivoter',
  'umoModifyDialog.inProgressMessage':
    'Ce processus peut prendre un certain temps. Il se poursuivra en arrière-plan.',
  'workspaceDownloadDialog.buttonDownload': 'Téléchargements',
  'workspaceDownloadDialog.autoEmailDownload':
    'This item is being generated in the background and will be sent to your email address',
  'workspaceDownloadDialog.emailDownload':
    'This item will be sent to the email address you have provided',
  'workspaceDownloadDialog.emailDynamicDownload':
    'This item is dynamically generated and will be sent to the email address you provide',
  'workspaceDownloadDialog.mainTitle': 'Télécharger le(s) média(s)',
  'workspaceDownloadDialog.optionsTitle':
    'Télécharger le contenu de l’espace de travail dans un fichier ZIP',
  'workspaceDownloadDialog.pdfDownloadTitle':
    'Créer un PDF avec le contenu de l’espace de travail',
  'workspaceDownloadDialog.optionsSubTitle':
    'Choisir le dérivé pour chaque type de média',
  'workspaceDownloadDialog.optionsPhoto': 'Image',
  'workspaceDownloadDialog.optionsVideo': 'Vidéo',
  'workspaceDownloadDialog.optionsAudio': 'Audio',
  'workspaceDownloadDialog.optionsDocuments': 'Document',
  'workspaceDownloadDialog.optionsItemsPerPage':
    'Choisir le nombre d’éléments par page',

  'workspacePreview.workspaceDetailsButton': 'Détails sur l’espace',
  'workspacePreview.options': 'Options',
  'workspacePreview.selection': 'Sélection',
  'workspacePreview.selection.selectAll': 'Tout sélectionner',
  'workspacePreview.selection.deselectAll': 'Tout désélectionner',
  'workspacePreview.actions': 'Actions',
  'workspacePreview.actions.removeSelectedFromWorkspace':
    'Enlever les éléments sélectionnés de l’espace',

  'utils.piction.moveCategoryGenericError':
    'Une erreur s’est produite. Veuillez réessayer.',
  'utils.piction.moveCategoryPermissionError':
    'Vous n’avez pas les permissions pour déplacer des éléments dans la catégorie sélectionnée',

  'metadataView.noMetadata':
    'Il n’y a pas de métadonnées disponibles pour l’OMU sélectionné',

  'newRelational.addNewRelational': 'Add New Record',
  'newRelational.configErr': 'Configuration Error.',
  'newRelational.contactAdminMsg':
    'Contact your system admin to use this feature',
  'highlight.curated.sets': 'Ensembles Organisés',

  'fileUploader.title': 'Piction File Uploader',
  'fileUploader.subTitle': 'Upload multiple files. Drag/drop your files below.',
  'fileUploader.uploadToCategoryLabel': 'Upload to Category: ',
  'fileUploader.dropAreaLabel': 'Drop here',
  'fileUploader.browseOrDropLabel': 'Click to browse or Drop here',
  'fileUploader.addMoreLabel': 'Add more',
  'fileUploader.addMetadata': 'Add Metadata',
  'fileUploader.fileList': 'File List',
  'fileUploader.itemsSelected': ' selected',
  'fileUploader.loadingLabel': 'Loading',
  'fileUploader.uploadingLabel': 'Uploading',
  'fileUploader.processingLabel': 'Processing files',
  'fileUploader.waitLabel': ', please wait',
  'fileUploader.fileUploadFail': 'Failed to upload file',
  'fileUploader.fileUploadFailFor': 'File upload failed for: {filename}',
  'fileUploader.fileUploadSuccess': ' successfully uploaded',
  'fileUploader.fileUploadPause': 'File upload stopped/paused for: {filename}',
  'fileUploader.nameExists':
    'Upload failed, file with the name {name} already exists',
  'fileUploader.maxFilesExceeded':
    'You have exceeded the maximum number of files allowed. You can only upload up to {maxCount} files.',
  'fileUploader.maxTotalFileSize':
    'Max total file size of {filesize} exceeded, please remove some files',
  'fileUploader.maxFilesize': 'Max file size',
  'fileUploader.invalidType': 'The file {fileName} is of an invalid type',
  'fileUploader.supportedFileTypes': 'Supported file types: ',
  'fileUploader.copyRowDown': 'Copy this row downwards',
  'fileUploader.copyRowUp': 'Copy this row upwards',
  'fileUploader.copyRowToRows': 'Copy this row to other rows',
  'fileUploader.copyCellDown': 'Copy this cell downwards',
  'fileUploader.copyCellUp': 'Copy this cell upwards',
  'fileUploader.copyCellToCell': 'Copy this cell to other cells',
  'fileUploader.metaUpdateSuccess': 'Metadata updated successfully',
  'fileUploader.metaUpdateFail': 'Failed to update metadata',
  'fileUploader.uploadInProgressMessage':
    'Upload in progress. Try again later.',
  'fileUploader.requiredMetadataMsg': 'This field is required.',
  'fileUploader.requiredMetadataError': 'Please fill in the mandatory fields.',

  'fileLoadingIndicator.uploads': 'Uploads',
  'fileLoadingIndicator.uploadComplete': 'Upload Process Completed',
  'fileLoadingIndicator.uploading': 'Uploading',
  'fileLoadingIndicator.pleaseWait': 'Please wait, this may take some time.',
  'fileLoadingIndicator.pleaseReview':
    "Please take a moment to review each file to ensure they've all uploaded successfully.",
  'fileLoadingIndicator.filterAll': 'All',
  'fileLoadingIndicator.filterQueued': 'Queued',
  'fileLoadingIndicator.filterUploading': 'Uploading',
  'fileLoadingIndicator.filterUploaded': 'Uploaded',
  'fileLoadingIndicator.filterFailed': 'Failed',
  'fileLoadingIndicator.filterDuplicated': 'Duplicated',
  'fileLoadingIndicator.noFilesFound':
    'No files found for the selected filter.',

  'metaInput.newEntry': 'New entry',
  'metaInput.addNewEntry': 'Add new entry',
  'metaInput.addNewRGroupEntry': 'Add new entry for {name}',
  'metaInput.existingEntries': 'Existing Entries',
  'metaInput.editField': 'Edit Field',
  'metaInput.entryNum': 'Entry #{number}',
  'metaInput.updateIndividually': 'Update Individually',
  'metaInput.bulkUpdate': 'Bulk Update',

  'imageEdit.rotateImage': 'Rotate Image',
  'imageEdit.mirrorImage': 'Mirror Image',
  'imageEdit.rotateImageSuccess': 'Succcessfully created new UMO',
};
